import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsResearchgateComponent } from './simple-icons-researchgate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsResearchgateComponent ],
    exports:      [ SimpleIconsResearchgateComponent ],
    bootstrap:    []
})
export class SimpleIconsResearchgateModule {}
